<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <!-- NOTE: WorkPackageSubPageModule does not work at all in dummy page -->
      <WorkPackageSubPageModule
        :workpackage="issues[0].parent"
        :isMobile="false/*isMobile*/"
        :location="location"
        :loading="false/*loading*/"
        :background_color="bg"
        :foreground_color="fg"
        header_icon="mdi-steering"
        :header_text_short="'AUTOPILOTS'/*$t('WorkpackageRework.Info.Log.Header')*/"
        :header_text_long="'AUTOPILOTS & ISSUES'/*$t('WorkpackageRework.Info.Log.Header').toUpperCase() + '.' + $t('WorkpackageRework.Info.Log.List')*/"
        @headerBack="$router.push({name: `${location}WorkPackageInfo`})"
      >
        <template #header-rightside>
          <v-btn
            icon
            :color="show_filter ? bg : fg"
            :class="show_filter ? workpackage.textcolor : ''"
            @click="show_filter = !show_filter"
          >
            <v-icon>filter_alt</v-icon>
          </v-btn>

          <v-btn
            icon
            :color="fg"
            @click="$router.push({
              name: `${location}WorkPackageLogListDetails`,
              params: {
                content_id: 'create'
              }
            })"
            >
            <v-icon>add</v-icon>
          </v-btn>
        <!-- <v-btn class="ma-1" icon :color="workpackage_fg_hex"><v-icon>add</v-icon></v-btn> -->
        </template>
        <template #header-below>
          <DropDown
            v-if="show_filter"
            placeholder="Filter"
            :items="['created', 'updated', 'deleted', 'added', 'removed', 'comment']"
            :value="$store.state.TWorkPackageLogList.log_list_filter_new"
            :clearable="true"
            :max_width="1000"
            :light="is_light_mode(fg)"
            :background_color="bg"
            :foreground_color="fg"
            @selected="setLogListFilterNew($event?$event:false), !$event?show_filter=false:''"
            style="z-index: 100;"
          />
        </template>
        <template #body>
          <!-- TODO: put div with for loop here -->
        </template>
      </WorkPackageSubPageModule>

      <CollapsableCategory
        value="AUTO.pilots"
        :color="fg"
      >
        <template #content="{ is_collapsed, }">
          <TransitionAccordion>
            <div v-if="!is_collapsed">
              <div
                v-for="(pilot, index) in [
                  {id: 1, name: 'erster pilot', count: 20, resolved: 19},
                  {id: 2, name: 'zweiter pilot', count: 4, resolved: 2},
                  {id: 3, name: 'dritter pilot', count: 9, resolved: 6},
                ]"
                class="work-package-autopilots"
                :key="`pilotitem${index}-${pilot.id}`"
              >
                <ClickableListItem
                  :id="pilot.id"
                  :is_selected="pilot.id === DEBUG_selected_issue /* TODO: check for appropriate id in route, NOTE: $route.params.content_id*/"
                  :is_disabled="false"
                  :has_lines="true"
                  :is_first="index == 0"
                  :background_color="bg"
                  :foreground_color="fg"
                  @emittedClick="$emit('clickList', pilot.id)"
                >
                  <!-- CLICKABLE LIST SLOTS -->
                  <template #front>
                    <v-icon :color="fg">mdi-steering</v-icon>
                  </template>

                  <template #descriptor>
                    <TText
                      :text="pilot.name"
                      :color="fg"
                      align="left"
                      medium
                    />
                  </template>
                  <template #info>
                    <TText
                      :text="`${pilot.resolved}/${pilot.count}`"
                      :color="fg"
                      align="left"
                      medium
                    />
                  </template>
                </ClickableListItem>
              </div>
            </div>
          </TransitionAccordion>
        </template>
      </CollapsableCategory>

      <CollapsableCategory
        value="Issues"
        :color="fg"
        :init_expanded="true"
      >
        <template #content="{ is_collapsed, }">
          <TransitionAccordion>
            <div v-if="!is_collapsed">
              <div
                v-for="(issue, index) in issues"
                class="work-package-autopilots"
                :key="`issueitem${index}-${issue.id}`"
              >
                <ClickableListItem
                  :id="issue.id"
                  :is_selected="issue.id === DEBUG_selected_issue /* TODO: check for appropriate id in route, NOTE: $route.params.content_id*/"
                  :is_disabled="false"
                  :has_lines="true"
                  :is_first="index == 0"
                  :background_color="bg"
                  :foreground_color="fg"
                  @emittedClick="$emit('clickList', issue.id)"
                >
                  <!-- CLICKABLE LIST SLOTS -->
                  <template #front>
                    <v-icon :color="fg">{{ getIssuesIcon(issue) }}</v-icon>
                  </template>

                  <template #descriptor>
                    <TText
                      :text="`${issue.autopilot.function}: Issue #${issue.uuid}`"
                      :color="fg"
                      align="left"
                      medium
                    />
                  </template>
                </ClickableListItem>
              </div>
            </div>
          </TransitionAccordion>
        </template>
      </CollapsableCategory>
    </div>
  </div>
</template>

<script>
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';

import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js';

  export default {
    components: {
      WorkPackageSubPageModule,
      ClickableListItem,
      CollapsableCategory,
      TText,
      TransitionAccordion,
    },

    props: [
      'location',
    ],

    mixins: [
      WorkPackageReworkMixin,
    ],

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',

      is_edit: true,
      show_filter: false,
      DEBUG_selected_issue: 1,
      DEBUG_selected_autopilot: 2,

      type: 'work',
      issues: [
        {
          id: 6,
          uuid: "6218e859ca7e6",
          status: "open",
          parent_type: "twork_package",
          parent:
            {
              id: 154745,
              name: "Blechner 2",
              token: "BL2",
              icon: "obj-package-4",
              color: "pink lighten-1",
              status: "done",
              stop_status: "none",
              textcolor: "black",
              taktarea_name:  "A",
              project_id: 72,
              train_id: 1158,
              taktarea_id: 8610,
              twaggon_id: 138577
            },
          text: "@Blechner 2 has been set to \"done\" when not all WORK.steps have been marked as \"done\".",
          autopilot:
            {
              id: 1,
              type: "workpackage",
              trigger: "user",
              trigger_interval: "none",
              function: "WorkPackageStatus",
              description: "description",
              level: 1,
              created: "2020-01-01 00:00:00 UTC",
              updated: "2020-01-01 00:00:00 UTC"},
              logentries: [
                {
                  id: 1254561,
                  action: "created",
                  target: "AUTOPILOT.issue",
                  user: "TAKT.ai",
                  value: "Issue 6218e859ca7e6 has been created. Blechner 2 has been set to \"done\" when not all WORK.steps have been marked as \"done\"",
                  old_value: "",
                  created: "2022-02-25 14:31:53 UTC",
                  updated: "2022-02-25 14:31:53 UTC",
                  crossed_out: false
                }
            ]
        },
        {
          id: 7,
          uuid: "5218e859ca7e6",
          status: "resolved",
          parent_type: "twork_package",
          parent:
            {
              id: 154745,
              name: "Blechner 2",
              token: "BL2",
              icon: "obj-package-4",
              color: "pink lighten-1",
              status: "done",
              stop_status: "none",
              textcolor: "black",
              taktarea_name:  "A",
              project_id: 72,
              train_id: 1158,
              taktarea_id: 8610,
              twaggon_id: 138577
            },
          text: "@Blechner 2 has been set to \"done\" when not all WORK.steps have been marked as \"done\".",
          autopilot:
            {
              id: 1,
              type: "workpackage",
              trigger: "user",
              trigger_interval: "none",
              function: "WorkPackageStatus",
              description: "description",
              level: 1,
              created: "2020-01-01 00:00:00 UTC",
              updated: "2020-01-01 00:00:00 UTC"},
              logentries: [
                {
                  id: 1254561,
                  action: "created",
                  target: "AUTOPILOT.issue",
                  user: "TAKT.ai",
                  value: "Issue 6218e859ca7e6 has been created. Blechner 2 has been set to \"done\" when not all WORK.steps have been marked as \"done\"",
                  old_value: "",
                  created: "2022-02-25 14:31:53 UTC",
                  updated: "2022-02-25 14:31:53 UTC",
                  crossed_out: false
                }
            ]
        },
        {
          id: 8,
          uuid: "7218e859ca7e6",
          status: "overruled",
          parent_type: "twork_package",
          parent:
            {
              id: 154745,
              name: "Blechner 2",
              token: "BL2",
              icon: "obj-package-4",
              color: "pink lighten-1",
              status: "done",
              stop_status: "none",
              textcolor: "black",
              taktarea_name:  "A",
              project_id: 72,
              train_id: 1158,
              taktarea_id: 8610,
              twaggon_id: 138577
            },
          text: "@Blechner 2 has been set to \"done\" when not all WORK.steps have been marked as \"done\".",
          autopilot:
            {
              id: 1,
              type: "workpackage",
              trigger: "user",
              trigger_interval: "none",
              function: "WorkPackageStatus",
              description: "description",
              level: 1,
              created: "2020-01-01 00:00:00 UTC",
              updated: "2020-01-01 00:00:00 UTC"},
              logentries: [
                {
                  id: 1254561,
                  action: "created",
                  target: "AUTOPILOT.issue",
                  user: "TAKT.ai",
                  value: "Issue 6218e859ca7e6 has been created. Blechner 2 has been set to \"done\" when not all WORK.steps have been marked as \"done\"",
                  old_value: "",
                  created: "2022-02-25 14:31:53 UTC",
                  updated: "2022-02-25 14:31:53 UTC",
                  crossed_out: false
                }
            ]
        },
      ],
    }),

    methods: {
      getIssuesIcon(issue) {
        switch (issue.status) {
          case 'resolved':
            return 'mdi-lock-outline';
          case 'overruled':
            return 'mdi-lock-alert-outline';
          case 'open':
            return 'mdi-lock-open-variant-outline';
          default:
            return 'mdi-alert-circle-outline';
        }
      },

      test() {
        console.log("test ok");
      },
    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 10px;
    margin-top: 0;
  }
  .work-package-autopilots {
    width: 100%;
  }
</style>
